import { render } from "./FaqPage.vue?vue&type=template&id=3b4d7374&scoped=true&ts=true"
import script from "./FaqPage.vue?vue&type=script&lang=ts"
export * from "./FaqPage.vue?vue&type=script&lang=ts"

import "./FaqPage.vue?vue&type=style&index=0&id=3b4d7374&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4d7374"]])

export default __exports__